<template lang="pug">
.card-list
	Card(
		v-for="(location, index) in activeLocations",
		:key="location.phoneNumber + '-' + index",
		:location="location",
		:index="index"
	)
	button.card-list__load.btn--secondary.btn--center(
		v-if="activeLocations.length < totalLocations && !isLoadingMore",
		@click.prevent="loadMore"
	) Load More
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import Card from "./Card.vue"

export default {
	name: "CardList",
	components: {
		Card
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters([
			"activeLocations",
			"totalLocations",
			"page",
			"isLoadingMore",
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		...mapActions([
			"sendLocationRequest"
		]),
		loadMore() {
			let currentPage;
			if (!this.page || typeof this.page != 'number') currentPage = 1;
			else currentPage = parseInt(this.page);
			this.setStateValue(['page', currentPage + 1]);
			this.sendLocationRequest([true, false]);
		},
	},
	created() {
		
	},
};
</script>


<style scoped lang="scss">
.card-list {
	flex: 1 1 44%;
	max-width: 44%;
	@include mqdn(lg_dn) {
		flex: 1 1 100%;
		max-width: 100%;
	}
	&__load {
		margin-bottom: 0;
	}
}
</style>